

























import { Component, Vue, Prop } from 'vue-property-decorator'
import { Room } from '@/class/room'
import { RoomStorage } from '@/class/roomStorage'
import Header from '@/components/Utils/Header.vue'
import RoomMemberList from '@/components/Lobby/RoomMemberList.vue'
import PlayerUI from './PlayerUI.vue'
import GameMaster from './GameMaster/GameMaster.vue'
import Regulation from '@/components/Regulation.vue'
import Advertisement from '@/components/Common/Advertisement.vue'
import TotalResult from './TotalResult.vue'
import Qr from '@/components/Utils/Qr.vue'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'
import InputText from '@/components/Utils/form/text/InputText.vue'
import HeadlineBorder from '@/components/Utils/headline/HeadlineBorder.vue'

@Component({
  components: {
    Header,
    PlayerUI,
    GameMaster,
    RoomMemberList,
    Regulation,
    Advertisement,
    TotalResult,
    Qr,
    BtnSquare,
    InputText,
    HeadlineBorder
  }
})

export default class Lobby extends Vue {
  @Prop() room!: Room;
  @Prop() playerId!: string;
  @Prop() isGallary!: boolean;
  roomStorage = new RoomStorage(this.room.id);
  newName = '';
  show = false;

  get self () {
    return this.room.self
  }

  get isRoomMaster () {
    return this.room.masterId === this.playerId && !this.isGallary
  }

  leave () {
    if (confirm('退室しますか？')) {
      this.room.removeRoomMember(this.playerId)
      this.roomStorage.removeData()
      this.$router.replace({ name: 'room', params: { roomId: this.room.id } })
    }
  }
}
